import moment from 'moment';
import systemTimeOffsetStore from 'client/generic/SystemTimeOffset/SystemTimeOffset.store';

import {getStudentStartTime} from '../assignmentPracticeView.utils';

/**
 * @typedef {import('../../resources/augmented/Assignment/AssignmentModel.v3').AssignmentModelV3} Assignment
 * @typedef {import('moment').Moment} Moment
 */

/**
 * If the assignment has a time limit, this returns the number of seconds the student has left
 * to complete the assignment. If there is no time limit, it returns null.
 *
 * @param {object} arg
 * @param {*} arg.assignment
 * @returns {?Moment} Moment
 */
export const getSecondsLeftInTimeLimit = ({assignment, classroomId, studentId}) => {
  const timeLimit = assignment.getTimeLimitFromSettings({
    classroomId,
    studentId
  });
  if (!timeLimit) {
    return null;
  }

  const startTime = getStudentStartTime({assignment});
  if (!startTime) {
    return timeLimit * 60;
  }

  const outOfTimeDate = moment(startTime).add(timeLimit, 'minutes');
  const now = systemTimeOffsetStore.getCurrentTime();
  return outOfTimeDate.diff(now, 'seconds');
};

export const renderSecondsAsTimeString = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 60 / 60);
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const seconds = totalSeconds % 60;
  return 'hh:mm:ss'
    .replace('hh', `${hours}`.padStart(2, '0'))
    .replace('mm', `${minutes}`.padStart(2, '0'))
    .replace('ss', `${seconds}`.padStart(2, '0'));
};

export const isTimerUndismissable = (secondsLeft) => secondsLeft < 120;
